import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-energy-leadership',
  templateUrl: './energy-leadership.component.html',
  styleUrls: ['./energy-leadership.component.scss']
})
export class EnergyLeadershipComponent implements OnInit {

    contentIndex = 0;
    
    options: any = [
        {
            title: "Introduction",
            active: true,
            content: "Energy Leadership refers to both a particular and unique form of leadership, and also, literally, to the process of leading energy so that it works for you, rather than against you.By learning and applying the principles and concepts of Energy Leadership, you can increase your ability to shift your own energy and the energy of those around you. When you do that, you will help inspire and motivate yourself and others, feel a greater sense of purpose, get more done with much less effort and stress, and constantly attract positive and powerful people and success to you."
        },
        {
            title: "Anabolic and Catabolic Energy",
            active: false,
            content: "For all practical purposes, there are two kinds of energy: anabolic and catabolic. Anabolic describes energy that is constructive, expanding, fueling, healing, and growth- oriented.Anabolic energy helps move you forward and achieve positive, long-term, successful results, and is useful in leading others in the same direction.Using anabolic energy allows you to have a more complete and conscious view of what is going on around you, and to more easily come up with solutions and innovations. Catabolic energy, on the other hand, is draining, resisting, and contracting energy. While catabolic energy provides you with an energetic boost to combat what you perceive to be a stressful situation, it also is distracting and acts like a blinder through which you only see a limited view of a situation, thus reducing the choices available to you. Though it may offer some short-term benefits, when used on a long term basis, it imparts mental, emotional, and physical tolls that are potentially destructive to you, to your organization, and to all those around you. Research shows that the most successful leaders in life are those with high levels of anabolic energy (Buck Galer, 2011 *).Those who lead using catabolic energy can get results in the short-term; however, they cannot sustain success.No matter who you are or what you do in life, increasing your anabolic energy level will help you better perform whatever you do."
        }
    ];
    currentActive: number = 0;

    constructor() {
        console.log(this.options);
    }

  ngOnInit() {
  }

  changeContentActive(event: any, current: string) {
      console.log("current", event);
      console.log("current", current);
      this.setAllFalse(this.options);
      let index = parseInt(event.target.selectedOptions["0"].id);
      this.options[index].active = true;
      this.contentIndex = index; 
  }

  setAllFalse(arrayName):void {
        for (var i = 0; i < arrayName.length; i++) {
            arrayName[i].active = false;
        }
  }

    nextContent() {
        this.currentActive = 1;
      this.contentIndex++;
      if (this.contentIndex >= this.options.length) {
          this.contentIndex--
      } else {
          this.setAllFalse(this.options);
          this.options[this.contentIndex].active = true;
      }
  }

    previusContent() {
        this.currentActive = 0;
      this.contentIndex--;
      if (this.contentIndex < 0) {
          this.contentIndex++
      } else {
          this.setAllFalse(this.options);
          this.options[this.contentIndex].active = true;
      }
  }

}
